import Vue from 'vue';
import Vuex from 'vuex';

//Modules
import language from './modules/language';
import sExchangeRate from './modules/sExchangeRate';
//pages
import sPaymentPage from './modules/pages/payment/sPaymentPage';
import sPaymentStatus from './modules/pages/payment/sPaymentStatus';
import sCPaymentList from './modules/pages/payment/sCPaymentList';
import sCSystemDeposit from './modules/pages/postPaid/sCSystemDeposit';
import cBookingDetail from './modules/pages/ticket/cBookingDetail';
import cTicketingDetail from './modules/pages/ticket/cTicketingDetail';
import sRefundDetail from './modules/pages/ticket/sRefundDetail';
import sExchangeDetail from './modules/pages/ticket/sExchangeDetail';
import sTicketingQueue from './modules/pages/ticket/sTicketingQueue';
import sPrepaidTopUp from './modules/pages/topUp/sPrepaidTopUp';
import sPostPaidTopUp from './modules/pages/topUp/sPostPaidTopUp';
import sSystemTopUp from './modules/pages/topUp/sSystemTopUp';
import sAllRefund from './modules/pages/ticket/sAllRefund';
import sAllExchange from './modules/pages/ticket/sAllExchange';

import sCMultiCitySearch from './modules/pages/multiCity/search/sCMultiCitySearch';

import sCSearch from './modules/pages/cSearch/sCSearch';
import sResult from './modules/pages/Result/sResult';
import sMLResult from './modules/pages/Result/sMLResult';
//import sSearchPage from './modules/pages/search/sSearchPage';
import sPaxPage from './modules/pages/pax/sPaxPage';
import sSetupPricing from './modules/pages/pricing/sSetupPricing';
import sManagePricing from './modules/pages/pricing/sManagePricing';
import sAssignPricing from './modules/pages/pricing/sAssignPricing';
//formStore
import sAgtReg from './modules/form/agent/sAgtReg';
import sAddUser from './modules/form/sAddUser';
import sAgtLogin from './modules/form/login/sAgtLogin';
import sManageUsers from './modules/pages/users/sManageUsers';
import sRolesPermissions from './modules/pages/users/sRolesPermissions';
import sSysLogin from './modules/form/login/sSysLogin';
import sCaptcha from './modules/form/captcha/sCaptcha';
import sApproveAgt from './modules/form/agent/sApproveAgt';
import sCountryList from './modules/form/sCountryList';
import sUserRoles from './modules/form/sUserRoles'
import sChangePassword from './modules/form/sChangePassword';
import sMain from './modules/sMain';

import sMenus from './modules/menus/sMenus'
import sCreatePricing from './modules/pages/pricing/sCreatePricing'
import sManageAgent from './modules/form/agent/sManageAgent'
//componentStore
import sCAgent from './modules/component/sCAgent';
import sCLanguagePicker from './modules/component/sCLanguagePicker';
import sCAirLine from './modules/component/sCAirLine';
import sCOrgCurrencyDp from './modules/component/sCOrgCurrencyDp'

import sDashBoard from './modules/pages/dashboard/sDashBoard'
import sStateList from './modules/form/sStateList';
import sCurrencyLs from './modules/form/sCurrencyLs';
import createPersistedState from "vuex-persistedstate";

import sPaymentSetup from "./modules/pages/tools/sPaymentSetup"
import sSettings from "./modules/settings/sSettings"
import sFlightSchedule from './modules/pages/crs/sFlightSchedule';
import sGuide from './modules/pages/help/sGuide';

import sCreditSaleReport from './modules/pages/report/sCreditSaleReport';
import sFareView from "./modules/pages/crs/sFareView"
import sContract from "./modules/pages/crs/sContract"
import sAgentGroup from "./modules/pages/agentGroup/sAgentGroup"
import sHotelSearch from "./modules/pages/hotelSearch/sHotelSearch"
import sHotelResult from './modules/pages/Result/hotel/sHotelResult';
import sHotelRoomResult from './modules/pages/Result/hotel/sHotelRoomResult';
import sSupplierGrp from './modules/pages/hms/sSupplierGrp';
import sGuestPage from './modules/pages/Result/hotel/sGuestPage';
import sHotelInfo from './modules/pages/hms/hotelInfo/sHotelInfo'
import shmsManage from './modules/pages/hms/shmsManage';
import sRatePlan from './modules/pages/hms/hotelInfo/sRatePlan';
import sTariff from './modules/pages/hms/hotelInfo/sTariff'
import sHotelTax from './modules/pages/hms/hotelInfo/hotelTax/sHotelTax'
import shmsMarkup from './modules/pages/hms/shmsMarkup'
import sHmsUser from './modules/pages/hms/user/sHmsUser'

Vue.use(Vuex);
import {getClientCode} from './../config/env-config'
import {ALL_CLIENT_CODE,LOCAL_STORAGE_KEYS} from './../../src/util/constants'
const clientCode = getClientCode()
let adminKey =LOCAL_STORAGE_KEYS.B2B_ADMIN.toString()+clientCode.toString()

const store = new Vuex.Store({
    //plugins: [createPersistedState()],
    plugins: [createPersistedState({
        key: adminKey,
        storage: window.sessionStorage
    })],
    modules: {
        language,
        sAddUser,
        sHotelTax,
        sRatePlan,
        sMain,
        sAgtReg,
        sManageUsers,
        sRolesPermissions,
        sAgtLogin,
        sUserRoles,
        sChangePassword,
        sCaptcha,
        sApproveAgt,
        sCountryList,
        sStateList,
        sSysLogin,
        sCurrencyLs,
        sCAgent,
        sExchangeRate,
        sMenus,
        sCLanguagePicker,
        sPaymentSetup,
        sPaxPage,
        sCSearch,
        sResult,
        sMLResult,
        sSetupPricing,
        sManagePricing,
        sCreatePricing,
        sCAirLine,
        sAssignPricing,
        sCOrgCurrencyDp,
        sManageAgent,
        sPaymentPage,
        sDashBoard,
        sTicketingQueue,
        sPrepaidTopUp,
        sSettings,
        sPostPaidTopUp,
        sPaymentStatus,
        sCPaymentList,
        sCMultiCitySearch,
        sSystemTopUp,
        sCSystemDeposit,
        cBookingDetail,
        sRefundDetail,
        sExchangeDetail,
        cTicketingDetail,
        sFlightSchedule,
        sContract,
        sGuide,
        sAgentGroup,
        sCreditSaleReport,
        sHotelSearch,
        sAllExchange,
        sAllRefund,
        sHotelResult,
        sFareView,
        sHotelRoomResult,
        sSupplierGrp,
        sGuestPage,
        shmsManage,
        sHotelInfo,
        sTariff,
        shmsMarkup,
        sHmsUser
    }

});

export default store;